import { isClient } from './isClient'

const isRunningPlaywright = isClient && 'Playwright' in window
export default isRunningPlaywright
